module.exports = __webpack_public_path__ + "static/media/foot.34df5ce0.png";